export enum ESolarSystemType {
  OFF_GRID = "OFF_GRID",
  HYBRID = "HYBRID",
  BACKUP = "BACKUP",
}
